import { Injectable } from '@angular/core';
import { Storage } from '@ionic/storage-angular';

@Injectable({
  providedIn: 'root'
})
export class StorageService {

  private _storage: Storage | null = null;

  constructor(
    private storage: Storage
  ) {
    this.init();
  }

  async init() {
    // If using, define drivers here: await this.storage.defineDriver(/*...*/);
    const storage = await this.storage.create();
    this._storage = storage;
  }

  // Create and expose methods that users of this service can
  // call, for example:
  public async get(key: string) {
    let data = JSON.parse(await this._storage?.get(key));
    return data == null ? [] : data;
  }

  // Create and expose methods that users of this service can
  // call, for example:
  public async set(key: string, value: any) {
    return await this._storage?.set(key, JSON.stringify(value));
  }

  logAll() {
    this._storage?.forEach((key, value, index) => {
      console.log('Storage', key, value, index);
    });
  }

  addFavorites(articleId: number): Promise<any> {
    return new Promise(async resolve => {
      let ids = await this.listFavorites();

      if (ids.includes(articleId) == false) {
        ids.push(articleId);

        await this.set('favorites', ids);
      }

      resolve(true);
    });
  }

  removeFavorites(articleId: number): Promise<any> {
    return new Promise(async resolve => {
      let ids = await this.listFavorites();

      if (ids.includes(articleId) == true) {
        for (var i = 0; i < ids.length; i++) {
          if (ids[i] == articleId) {
            ids.splice(i, 1);
          }
        }

        await this.set('favorites', ids);
      }

      resolve(true);
    });
  }

  listFavorites(): Promise<any> {
    return new Promise(async resolve => {
      resolve(await this.get('favorites'));
    });
  }

  addRecently(articleId: number): Promise<any> {
    return new Promise(async resolve => {
      let ids = await this.listRecently();

      if (ids.includes(articleId) == false) {
        ids.push(articleId);

        await this.set('recently', ids);
      }

      resolve(true);
    });
  }

  listRecently(): Promise<any> {
    return new Promise(async resolve => {
      resolve(await this.get('recently'));
    });
  }

}
